export const typography = {
    fontFamily: "'Work Sans', sans-serif",

}